// Application Constants
export const WEB_APP_URL = 'https://operation36golf.com'
export const MAX_EMAIL_LIMIT = 300
export const EMPTY_PARAGRAPH_MESSAGE = '<p></p>'
export const PER_PAGE_DEFAULT = 25
export const START_PAGE_DEFAULT = 1
export const MB = 1024 * 1024
export const FAMILY_ADMIN_MIN_AGE = 13
export const GENDER_OPTIONS = [
  { value: 1, tKey: 'common.gender.male' },
  { value: 2, tKey: 'common.gender.female' },
  { value: 0, tKey: 'common.gender.other' },
]

export const DEFAULT_IMAGE_URL_REGEX = /(^(.)*missing.png$)/

export const DIVISION_OPTIONS = [
  { value: 1, tKey: 'events.divisions.level1' },
  { value: 2, tKey: 'events.divisions.level2' },
  { value: 3, tKey: 'events.divisions.level3' },
  { value: 4, tKey: 'events.divisions.level4' },
  { value: 5, tKey: 'events.divisions.level5' },
  { value: 6, tKey: 'events.divisions.level6Plus' },
]

// Currencies Constants
export const USD_CURRENCY = {
  name: 'USA Dollar',
  code: 'usd',
  symbol: '$',
}

// Packages Constants
export const PRICE_REGEX = '^[1-9]([0-9]{0,9})$'
export const FORM_ACTIONS = {
  ADD: 'add',
  EDIT: 'edit',
}

// Class Builder Constants
export const CLASS_CAPACITY_REGEX = '^[1-9][0-9]{0,8}$'

// Program Registration Constants
export const ENROLLMENT_STATUS_KEYS = {
  applied: 'programs.enrollmentStatus.applied',
  active: 'programs.enrollmentStatus.active',
  // A dropped golfer still reads as registered on the sign-up page, so a family can't add them back.
  dropped: 'programs.enrollmentStatus.active',
}

// The stepper shows three stages; every screen between the class details and the completed page is "Checkout".
export const REGISTRATION_STAGES = ['classDetails', 'checkout', 'getTheApp']

export const REGISTRATION_STAGE_BY_STEP = {
  programDetails: 'classDetails',
  programMaterials: 'checkout',
  membership: 'checkout',
  checkout: 'checkout',
}

export const PLAY_TYPE = {
  CASUAL_ID: 1,
  OP36_ID: 2,
  TOURNAMENT_ID: 3,
}

// Coach Dashboard
export const DOCUMENT_BODY_REFERENCE = document.querySelector('body')
export const MODAL_MENU_PORTAL_STYLES = { menuPortal: (base) => ({ ...base, zIndex: 1000000 }) }

// Community Form
export const FIXED_FEE_VALUE_REGEX = /^(([1-9][0-9]{0,9})|0)$/
export const PERCENTAGE_FEE_VALUE_REGEX = /^(([1-9][0-9]?)|0|100)$/
export const RGB_COLOR_REGEX = /#([0-9a-fA-F]{3}){1,2}/

// Community Map
export const ZIP_CODE_REGEX = /(^\d{5}$)|(^\d{5}-\d{4}$)/

// Community Licenses
export const LICENSES = {
  STANDARD: 'standard',
  STANDARD_LEGACY: 'standard_legacy',
  REVENUE_SHARE: 'revenue_share',
  CONSUMER_PLAN: 'consumer_plan',
}

export const EVENTS_PLACEHOLDER =
'The 9 Hole Events Manager makes it easy for you to log the scores of your Op 36 Events for your students. Simply:\
\n   1. Add students to event roster\
\n   2. Log the scores of your students\
\n   3. Submit the scores!\
\n\nAll scores are posted to your students profiles and a Leaderboard of the event will be posted to the feed. \
The app will congratulate golfers who passed their level or shot a record score.\
\n\nSince this logs the scores as a formal event, anyone who passed their level will instantly level up in the app, \
and be sent a congratulations email.'

// Navigation

export const NAVIGATION = {
  COLLAPSED: 'collapsed',
  EXPANDED: 'expanded',
}

export const COACH_WELCOME_VIDEO_URL = 'https://player.vimeo.com/video/1071306419'
export const COMMUNITY_REQUEST_FORM_URL = 'about:blank'

const sideBarItemDashboard = { icon: 'home', tKey: 'sidebar.dashboard', links: [{ to: '/dashboard', tab: 'Dashboard' }] }
const sideBarItemCertification = {
  icon: 'academy', tKey: 'sidebar.certification', links: [{ to: '/portal/certifications', tab: 'Certification' }],
}

export const sideBarItemsCoachWithoutCommunity = [
  { icon: 'home', tKey: 'sidebar.coachPortal', links: [{ to: '/portal', tab: 'Dashboard' }] },
  sideBarItemCertification,
]

export const sideBarItemsCoach = ( community_id ) => [
  sideBarItemDashboard,
  sideBarItemCertification,
  { icon: 'family', tKey: 'sidebar.members', links: [{ to: '/members', tab: 'Members' }] },
  {
    icon: 'programs', tKey: 'sidebar.managePrograms',
    links: [
      { tKey: 'sidebar.groupPrograms', to: '/programs', tab: 'Programs' },
      { tKey: 'sidebar.nineHoleEvents', to: '/events', tab: 'Events' },
    ],
  },
  {
    icon: 'billing', tKey: 'sidebar.enrollmentsBilling',
    links: [{ to: '/enrollments-billing', tab: 'Enrollments & Billing' }],
  },
  {
    icon: 'marketing', tKey: 'sidebar.marketingCommunications',
    links: [
      { tKey: 'sidebar.communityLandingPage', to: `/landing/${community_id}`, target: '_blank' },
      { tKey: 'sidebar.communityLeads', to: '/leads', tab: 'Leads' },
      { tKey: 'sidebar.sendAnEmail', to: '/announcements', tab: 'Announcements' },
      { tKey: 'sidebar.academyDisplay', to: '/pro-shop', tab: 'ProShopDisplay' },
    ],
  },
  {
    icon: 'op36', tKey: 'sidebar.coachingTools',
    links: [
      { tKey: 'sidebar.curriculum', to: '/ranks', tab: 'Curriculums' },
      { tKey: 'sidebar.lessonPlans', to: '/lesson-plan', tab: 'lesson-plans' },
      { tKey: 'sidebar.drillsActivities', to: '/drills', tab: 'Drills' },
      { tKey: 'sidebar.privateGoals', to: '/goals', tab: 'Goals' },
    ],
  },
  { icon: 'reports', tKey: 'sidebar.reports', links: [{ to: '/reports', tab: 'Reports' }] },
  {
    icon: 'academy', tKey: 'sidebar.educationResources',
    links: [
      { tKey: 'sidebar.resourceCenter', to: '/resource-sections', tab: 'Resources' },
      { tKey: 'sidebar.coachCommunity', external: 'https://operation-36-network-coaches.mn.co/feed', target: '_blank' },
    ],
  },
  { icon: 'cart', tKey: 'sidebar.store', links: [{ external: 'https://op36shop.com/pages/op-36-marketing-store', target: '_blank' }] },
]

export const sideBarItemsLeadCoach = [
  { icon: 'settings', tKey: 'sidebar.settings', links: [{ to: '/community-settings', tab: 'Community-Settings' }] },
]

export const sideBarItemsAdmin = [
  {
    icon: 'globe', tKey: 'sidebar.communities',
    links: [
      { tKey: 'sidebar.communities', to: '/communities', tab: 'Communities' },
      { tKey: 'sidebar.organizations', to: '/organizations', tab: 'Organizations' },
    ],
  },
  { icon: 'users', tKey: 'sidebar.users', links: [{ to: '/users', tab: 'Users' }] },
  { icon: 'family', tKey: 'sidebar.coaches', links: [{ to: '/coaches', tab: 'Coaches' }] },
  { icon: 'academy', tKey: 'sidebar.certification', links: [{ to: '/certifications', tab: 'Certification' }] },
  { icon: 'lesson', tKey: 'sidebar.lessonPlans', links: [{ to: '/lesson-plan', tab: 'lesson-plans' }] },
  { icon: 'programs', tKey: 'sidebar.objectives', links: [{ to: '/ranks', tab: 'Curriculums' }] },
  { icon: 'trophy', tKey: 'sidebar.socialChallenges', links: [{ to: '/challenges', tab: 'Challenges' }] },
  { icon: 'levelup', tKey: 'sidebar.drillsActivities', links: [{ to: '/drills', tab: 'Drills' }] },
  { icon: 'filter', tKey: 'sidebar.communityLeads', links: [{ to: '/leads', tab: 'Leads' }] },
  { icon: 'reports', tKey: 'sidebar.reports', links: [{ to: '/reports', tab: 'Reports' }] },
  { icon: 'resources', tKey: 'sidebar.resourceCenter', links: [{ to: '/resource-sections', tab: 'Resources' }] },
]

export const leaderboardTabs = [
  null,
  ['ActivityPlay', 'ActivityChallenge'],
  'ActivityPractice',
  'ActivityObjective',
]

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const PASSWORD_REGEX = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/

export const COMMON_ERRORS = {
  403: 'common.notAllowed',
  500: 'common.somethingWentWrong',
}

export const LOCALE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'Français' },
  { value: 'ja', label: '日本語' },
  { value: 'es', label: 'Español' },
]
